<template>
  <div class="case-page">
    <div class="w1200">
      <h1 class="page-title" v-animate>{{ $t("case.info1") }}</h1>
      <p v-animate>{{ $t("case.info2") }}</p>

      <div v-animate @click="handleOpen" class="btn-box">{{ $t("case.info3") }}</div>

      <div class="case-contnet">
        <case-item
          v-animate
          :data="item"
          v-for="(item, index) in caseData"
          :key="index"
        ></case-item>
      </div>

      <div class="case-footer mt-[50px] pb-[171px]">
        <h2 class="page-title mb-[50px]">
          <p v-animate>{{ $t("case.text36") }}</p>
          <p v-animate>{{ $t("case.text37") }}</p>
        </h2>

        <div v-animate @click="handleOpen" class="btn-box">{{ $t("case.text38") }}</div>
      </div>
    </div>
  </div>

  <img
    class="w-[100px] h-[131px] fixed right-[40px] top-[48vh] cursor-pointer"
    :src="toolImg"
    alt=""
    @click="handleOpen"
  />

  <contactDialog v-model="showDialog"></contactDialog>
</template>

<script setup lang="ts">
import caseItem from "./components/casetItem.vue";
import contactDialog from "@/components/Dialog/contactDialog.vue";
import { usePageCase } from "@/hooks/usePageCase";

const { caseData, toolImg, showDialog, handleOpen } = usePageCase();
</script>

<style lang="scss" scoped>
.w1200 {
  width: 1200px;
  margin: auto;
}

.page-title {
  font-family: Libre Baskerville, Libre Baskerville;
  font-weight: 400;
  font-size: 64px;
  color: #000000;
}

.case-page {
  text-align: center;
  padding-top: 190px;
  background: #fefcff;
  h1 {
    margin-bottom: 20px;
  }
  > div > p {
    font-family: PingFang SC, PingFang SC;
    font-weight: 300;
    font-size: 20px;
    color: #858481 !important;
    margin-bottom: 60px;
  }

  .btn-box {
    width: 272px;
    margin: auto;
    height: 56px;
    font-family: PingFang HK, PingFang HK;
    font-weight: 600;
    font-size: 18px;
    color: #ffffff;
    background-image: url("@/assets/images/influenbase-btn-bg.png");
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 0.8;
    transition: all 0.3s;
    margin-top: 40px;
    &:hover {
      opacity: 1;
    }
  }
  .case-contnet {
    margin-top: 133px;
  }
}
</style>
